<template>
    <div class="visitorLogin">
        <div style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.6);"></div>
        <div class="visitorLoginBox">
            <div class="visitorTitle">进入直播间</div>
            <div class="visitorLoginContent">
                <img class="visitorAvator" src="../assets/imgs/login/avator.png" alt="访客登录">
                <div class="visitorInputBox">
                    <input class="vistorInput" type="text" v-model="nickname" placeholder="请输入昵称" />
                </div>
                <div class="visitorBtn" @click="login">立即进入</div>
            </div>
        </div>
    </div>
</template>
<script>
import tool from '../kits/Tools'
import qs from 'qs'
export default {
  props: ['dsInfo'],
  data () {
    return {
      nickname: `Guest_${Date.now()}`,
      headimgurl: 'https://shkt-online-live-1317978474.cos.accelerate.myqcloud.com/shanhu_res/defaultAvatar/avator.png'
    }
  },
  methods: {
    async login () {
      if (!this.nickname) {
        this.$message('请输入昵称...')
        return
      }

      if (!this.dsInfo) {
        this.$message('直播间信息获取失败，请稍后再试...')
        return
      }
      console.log('访客登录', this.dsInfo)
      //  tool.baseUrl2() + '/liveapi/api/user/login/visitorLogOn,'channel_code=' + this.channel_id
      let postData = {
        ds_id: this.dsInfo.direct_seeding.ds_id,
        uid: this.dsInfo.direct_seeding.uid,
        nickname: this.nickname,
        headimgurl: this.headimgurl
      }
      try {
        // https://preview_live.shkt.online/liveapi
        const data = await this.axios.post(`${tool.baseUrl2()}/api/user/login/visitorLogOn`, qs.stringify(postData))
        console.log('访客登录返回', data)
        // 处理登录成功的逻辑
        // eslint-disable-next-line eqeqeq
        if (data.data.code == 200) {
          const userInfo = data.data.data
          const token = userInfo.token
          tool.setCookie('userInfo', JSON.stringify(userInfo), 30)
          tool.setCookie('token', token, 30)
          this.$emit('login')
        }
      } catch (error) {
        console.error('访客登录失败', error)
      }
    }
  }
}
</script>
<style scoped>
.visitorLogin {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2024;
}

.visitorLoginBox {
    width: 374px;
    height: 340px;
    position: absolute;
    z-index: 1;
    top: 15%;
    left: 50%;
    transform: translate(-50%, 0);
    background: url('../assets/imgs/login/visitorbg.png') no-repeat;
    background-size: 100% 100%;
    border-radius: 10px;
}

.visitorTitle {
    color: #FFF;
    text-align: center;
    text-shadow: 2px 2px 4px rgba(0, 85, 164, 0.40);
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding-top: 25px;
    padding-bottom: 15px;
}

.visitorLoginContent {
    padding-top: 12px;
    border-radius: 40px 40px 0 0;
    background-color: #FFF;
    text-align: center;

}

.visitorAvator {
    width: 60px;
    height: 60px;
    border-radius: 50%;
}

.vistorInput {
    text-align: center;
    margin-top: 10px;
    width: 100%;
    border: none;
    box-sizing: border-box;
}

.visitorInputBox {
    height: 40px;
    margin: 10px 20px 0px 20px;
    position: relative;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid #E0E0E0;
}

.visitorBtn {
    height: 40px;
    line-height: 40px;
    text-align: center;
    padding: 0px 8px;
    margin: 30px 20px 0px 20px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    color: #FFF;
    background: #0084FF;
    border-radius: 10px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/VisitorLogin.vue